import { createFetchActions } from '../createFetchActions';
import { getFetchHeaders } from '../getFetchHeaders';
import { getFetchResponseData } from '../getFetchResponseData';
import { success, error } from '../utils';
import {
  SUBMIT_TIME_ENTRY,
  HANDLE_TIME_ENTRY_INPUT_CHANGE,
  UPDATE_SELECTED_DAYS,
  SET_SHOW_BULK_ENTRY_MODAL,
  LOADING_ADD_TASK,
  LOADING_ADD_TASK_SUCCESS,
  LOADING_ADD_TASK_ERROR,
  ADD_TIME_ENTRY_BULK,
  REMOVE_PROJECT_ENTRY,
  DELETE_PROJECT,
  DELETE_PROJECT_SUCCESS,
  DELETE_PROJECT_ERROR,
  LOADING_CALENDAR_COMPLETION,
  SETUP_CATEGORIES,
  UPDATE_HOURS_ENTERED,
} from './types';
import { SupportedSystems } from '../../shared/index.js';

export const actionCreators = {
  setupCategories: (oid) =>
    createFetchActions({
      startAction: SETUP_CATEGORIES,
      url: `/api/timetracker/admin/${oid}/setupCategories`,
    }),
  requestMonthlyCompletion: (oid, dateOfMonth, additionalMonths) => {
    return async (dispatch) => {
      const date = new Date(dateOfMonth).toISOString().split('T')[0];
      let url = `/api/v2/timetracker/monthDetail?UserId=${oid}&Date=${date}`;
      if (additionalMonths) {
        url += `&AdditionalMonths=${additionalMonths}`;
      }

      const headers = await getFetchHeaders();
      return fetch(url, {
        method: 'GET',
        headers: headers,
      })
        .then((res) => getFetchResponseData(res))
        .then((data) => {
          dispatch({
            type: success(LOADING_CALENDAR_COMPLETION),
            payload: data,
          });
        })
        .catch((e) => {
          dispatch({ type: error(LOADING_CALENDAR_COMPLETION), payload: e });
        });
    };
  },
  handleSubmit: (timeEntry, currentSystem) =>
    createFetchActions({
      method: 'POST',
      body: timeEntry,
      startAction: SUBMIT_TIME_ENTRY,
      url: `/api/timetracker/${currentSystem}`,
    }),
  addTimeEntryBulk: (timeEntries, type, isAdmin) =>
    createFetchActions({
      method: 'POST',
      body: timeEntries,
      startAction: ADD_TIME_ENTRY_BULK,
      url: `api/system/${type}/bulktime${isAdmin ? '/admin' : ''}`,
    }),

  updateSelectedDays: (selectedDays) => ({
    type: UPDATE_SELECTED_DAYS,
    selectedDays,
  }),
  updateAllDates: (selectedDays, activeMonth) => ({
    type: UPDATE_SELECTED_DAYS,
    selectedDays,
    activeMonth,
  }),
  handleTimeEntryInputChange: (inputEntry) => ({
    type: HANDLE_TIME_ENTRY_INPUT_CHANGE,
    inputEntry,
  }),
  setShowBulkEntryModal: (show) => ({
    type: SET_SHOW_BULK_ENTRY_MODAL,
    show,
  }),
  addTask: (values, type) => {
    return async (dispatch) => {
      dispatch({ type: LOADING_ADD_TASK });
      var headers = await getFetchHeaders();
      return fetch(`/api/system/${type}/task`, {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(values),
      })
        ?.then((response) => getFetchResponseData(response))
        ?.then((payload) =>
          dispatch({
            type: LOADING_ADD_TASK_SUCCESS,
            payload,
          })
        )
        ?.catch((err) => {
          dispatch({ type: LOADING_ADD_TASK_ERROR, err });
          return Promise.reject(err);
        });
    };
  },
  removeProjectEntry: (projectNumber) => ({
    type: REMOVE_PROJECT_ENTRY,
    projectNumber,
  }),
  getAdminEntries: (oid, date) => {
    return async () => {
      var headers = await getFetchHeaders();
      var url = `api/TimeTracker/admin/${oid}/${date}`;
      return fetch(url, {
        method: 'GET',
        headers: headers,
      }).then((res) => getFetchResponseData(res));
    };
  },
  getEditableDatesByProjectByWeek: (projectNumber, startDate) => {
    return async () => {
      var headers = await getFetchHeaders();
      var url = `api/v2/TimeTracker/projectEntries/editableDates?ProjectNumber=${projectNumber}&StartOfWeek=${startDate}`;
      return fetch(url, {
        method: 'GET',
        headers: headers,
      }).then((res) => getFetchResponseData(res));
    };
  },
  deleteProject: (
    currentSystem,
    oid,
    projectNumber,
    startDate,
    endDate,
    forceDelete
  ) => {
    return async (dispatch) => {
      dispatch({ type: DELETE_PROJECT });
      var headers = await getFetchHeaders();
      var url = `api/system/${currentSystem}/${oid}/${projectNumber}/${startDate}/${endDate}`;
      if (forceDelete) {
        url += `?forceDelete=${forceDelete}`;
      }
      return fetch(url, {
        method: 'POST',
        headers: headers,
      })
        ?.then((response) => getFetchResponseData(response))
        ?.then((payload) =>
          dispatch({
            type: DELETE_PROJECT_SUCCESS,
            payload,
          })
        )
        ?.catch((err) => {
          dispatch({ type: DELETE_PROJECT_ERROR, err });
          return Promise.reject(err);
        });
    };
  },
  updateCompletedWeeks: (amount, updateCompletedMonth) => ({
    type: UPDATE_HOURS_ENTERED,
    payload: { amount, updateCompletedMonth }
  }),
};
